import createTypedReducer, { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";
import includes from "lodash/includes";

export default interface MarketingStateType {
    sliderDrawerIsOpen?: boolean;
}

const initialMarketingState: MarketingStateType = {
    sliderDrawerIsOpen: undefined,
};

export const marketingReducer = createTypedReducerWithImmer(initialMarketingState, {
    "Custom/Marketing/SetSliderDrawerIsOpen": (draft: Draft<MarketingStateType>, action: any) => {
        draft.sliderDrawerIsOpen = action.sliderDrawerIsOpen;
    },
});

(reducers as any).marketingReducer = marketingReducer;

export type StoreMarketingState = {
    marketingReducer: MarketingStateType;
} & ApplicationState;

type Reducers = {
    marketingReducer: typeof marketingReducer;
};

export type StoreMarketingActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
